import * as React from 'react';
import ouiDom
  from '@goldwasserexchange/oui-dom';
import { Trans } from '@lingui/macro';
import ouiStyle from '@goldwasserexchange/oui-style';
import { newsLetterSubmitErrorState, resetNewsLetterStates } from '../../../../state';
import { NewsLetterErrorReturnButtonWrapper } from './components';

const onClick = () => {
  resetNewsLetterStates();
  newsLetterSubmitErrorState.set(false);
};

export const NewsLetterErrorReturnButton = () => (
  <NewsLetterErrorReturnButtonWrapper>
    <ouiDom.Button.Button
      type="button"
      onClick={onClick}
      color={ouiStyle.Constants.Colors.inverted}
      backgroundColor={ouiStyle.Constants.Colors.primary}
      hoverBackgroundColor={ouiStyle.Constants.Colors.primaryShaded}
      borderColor={ouiStyle.Constants.Colors.primary}
    >
      <Trans>
        Réessayer
      </Trans>
    </ouiDom.Button.Button>
  </NewsLetterErrorReturnButtonWrapper>
);
